import type { NavigationMenuItem } from '@nuxt/ui'

export const navLinks: NavigationMenuItem[][] = [[
  {
    label: 'Home',
    icon: 'i-lucide-home',
    to: '/'
  },
  {
    label: 'Explorar',
    icon: 'i-lucide-layout-grid',
    to: '#'
  },
  {
    label: 'Recordes',
    icon: 'i-lucide-trophy',
    to: '#'
  },
  {
    label: 'Favoritos',
    icon: 'i-lucide-heart',
    to: '#'
  }
],
[
  {
    label: 'Atendimento',
    icon: 'i-lucide-headset',
    to: '#'
  }
]]
